import {StringUDF} from "./UDFs/StringUDF";
import {NumberUDF} from "./UDFs/NumberUDF";

export class IdentifyItemConfiguration {

  DefaultMode: StringUDF;

  FieldValueSOH: StringUDF;

  FilterLabelRFID: StringUDF;

  FilterLabelSKU: StringUDF;

  FilterLabelSOHSerial: StringUDF;

  FilterLabelSOHStoreID: StringUDF;

  FilterLabelUPC: StringUDF;

  IdentifyProductReportId: NumberUDF;

  IdentifyItemReportId: NumberUDF;

  SOHReportId: NumberUDF;

  get(): any {
    return {
      DefaultMode: this.DefaultMode.value,
      FieldValueSOH: this.FieldValueSOH.value,
      FilterLabelRFID: this.FilterLabelRFID.value,
      FilterLabelSKU: this.FilterLabelSKU.value,
      FilterLabelSOHSerial: this.FilterLabelSOHSerial.value,
      FilterLabelSOHStoreID: this.FilterLabelSOHStoreID.value,
      IdentifyItemReportId: this.IdentifyItemReportId.value,
      SOHReportId: this.SOHReportId.value,
      IdentifyProductReportId: this.IdentifyProductReportId
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/identifyItem.config.ts